import { useEffect, useState } from "react"
import { getPaymentResult } from "../../../services/ntuc/paymentService/payment"
import { searchParams } from '../../../helpers/search-params'
import RecurringPaymentSuccessPage from "../../../components/Acknowledgement/RecurringPayment/PaymentSuccess/RecurringPaymentSuccessPage"
import { getPayment, OrderStatus, PaymentResponse } from "../../../services/ntuc/memberService/payment"
import RecurringPaymentFailurePage from "../../../components/Acknowledgement/RecurringPayment/PaymentFailure/RecurringPaymentFailurePage"
import { MembershipPaymentRoute, MembershipPaymentRouteProps } from "../../membership-payment-flow/MembershipPaymentFlow/MembershipPaymentFlow"
import PaymentInfoError from "../../../components/Acknowledgement/PaymentInfoError/PaymentInfoError"
import { CircularProgress, Grid } from "@mui/material"
import { trackSignUpStep } from "../../../helpers/gtm"
interface RecurringPaymentAcknowledgementPageProps extends MembershipPaymentRouteProps {
    orderId?: string
    membershipId: string
}

interface PaymentInfo {
    isRecurring: boolean | null
    membershipId: string
    orderStatus: OrderStatus
}

const RecurringPaymentAcknowledgementPage = (props: MembershipPaymentRouteProps) => {
    const { onNavigateTo } = props

    const [orderId, setOrderId] = useState<string>()
    const [payment, setPayment] = useState<PaymentInfo>()
    const [hasError, setHasError] = useState<boolean>(false)

    const transformData = (content: PaymentResponse) => {
        return {
            isRecurring: content.payment.isRecurringPayment,
            membershipId: content.membershipPayment.membershipId,
            orderStatus: content.payment.orderStatus,
        }
    }

    const data = searchParams.Data
    const iv = searchParams.IV
    const tag = searchParams.tag || searchParams.Tag

    useEffect(() => {
        if (data && iv && tag) {
            getPaymentResult(data, iv, tag)
                .then(response => response.data.content.clientOrderId)
                .then(setOrderId)
                .catch(error => {
                    setHasError(true)
                    console.error(error.message)
                })
        }
    }, [data, iv, tag])

    useEffect(() => {
        if (orderId) {
            getPayment(orderId)
                .then(response => {
                    console.log(response.data.content)
                    const statusPayment = response.data.content.payment.orderStatus
                    trackSignUpStep(`Payment_${statusPayment}`)
                    return response
                })
                .then(response => response.data.content)
                .then(transformData)
                .then(setPayment)
                .catch(error => {
                    setHasError(true)
                    console.error(error.message)
                })
        }
    }, [orderId])

    const handleHomeClick = () => {
        onNavigateTo(MembershipPaymentRoute.Main)
    }

    if (hasError) {
        return <PaymentInfoError onHomeClick={handleHomeClick} />
    }

    if (payment != undefined) {
        switch (payment.orderStatus) {
            case OrderStatus.SUCCESS:
                return <RecurringPaymentSuccessPage membershipId={payment.membershipId} orderId={orderId} onNavigateTo={onNavigateTo} />
            case OrderStatus.FAILED:
            case OrderStatus.CANCELLED:
                return <RecurringPaymentFailurePage membershipId={payment.membershipId} orderId={orderId} onNavigateTo={onNavigateTo} />
        }
    }

    return (
        <Grid container item justifyContent="center" py={6} xs={12}>
            <CircularProgress />
        </Grid>
    )
}

export default RecurringPaymentAcknowledgementPage
export type { RecurringPaymentAcknowledgementPageProps }